export default "__VITE_ASSET__ki0kv4RH__"